import { PLATFORM_ICON_MAP } from "../../../shared/constants";

interface AccountInfoProps {
  authorizeType: string;
  email: string;
  accountId?: string
}

const AccountInfo = ({
  authorizeType,
  email,
  accountId
}: AccountInfoProps) => {

  return (
    <div className="mt-3">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <div className="w-9 h-9 bg-white rounded-lg border border-gray-200 flex items-center justify-center shadow-sm">
            <img
              src={PLATFORM_ICON_MAP[authorizeType]}
              alt={authorizeType}
              className="w-6 h-6 object-contain"
            />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-gray-900 mb-1 truncate">
            {email}
          </h3>
          <p className="text-xs text-gray-900 font-mono">
            {accountId || "-"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccountInfo;
